<template>
    <div class="complain-status-page">
      <Navbar />
  
      <div class="container py-4">
        <div class="d-flex flex-column flex-md-row justify-content-between align-items-center mb-4 pt-3">
          <h2 class="mb-3 mb-md-0">
            <span class="badge badge-primary px-4 py-2 shadow-sm">Complaint Status</span>
          </h2>
          
          <div class="search-box w-100 w-md-50">
            <div class="input-group shadow-sm">
              <div class="input-group-prepend">
                <span class="input-group-text bg-white border-right-0">
                  <i class="fas fa-search text-muted"></i>
                </span>
              </div>
              <input 
                class="form-control border-left-0 pl-0" 
                type="text" 
                v-model="searchQuery" 
                placeholder="Search by name or device"
              >
            </div>
          </div>
        </div>
  
        <div class="card border-0 shadow-sm rounded d-none d-lg-block">
          <div class="table-responsive">
            <table class="table table-hover align-middle mb-0 text-center">
              <thead class="bg-light">
                <tr>
                  <th>ID</th>
                  <th>Complained by</th>
                  <th>Device</th>
                  <th>Nature</th>
                  <th>Summary</th>
                  <th>Time</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in resultQuery" :key="index" @click="openModal(item)" class="clickable-row">
                  <td><span class="text-muted small">{{ item.complain_id }}</span></td>
                  <td class="font-weight-bold">{{ item.name }}</td>
                  <td><span class="badge badge-light border text-dark">{{ item.Device_Name }}</span></td>
                  <td>{{ item.complain_Nature }}</td>
                  <td class="text-truncate" style="max-width: 150px;" :title="item.complain_log">
                    {{ item.complain_log }}
                  </td>
                  <td class="small text-muted">{{ parseDateString(item.updated_date) }}</td>
                  <td>
                    <span :class="getStatusClass(item.status)" class="status-pill">
                      {{ item.status }}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
  
        <div class="d-lg-none">
          <div v-for="(item, index) in resultQuery" :key="'mob-' + index" @click="openModal(item)" class="mobile-card card mb-3 border-0 shadow-sm clickable-row">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-start mb-2">
                <h6 class="font-weight-bold text-primary mb-0">{{ item.name }}</h6>
                <span :class="getStatusClass(item.status)" class="status-pill small">
                  {{ item.status }}
                </span>
              </div>
              <div class="row small text-muted">
                <div class="col-6"><strong>ID:</strong> #{{ item.complain_id }}</div>
                <div class="col-12 mt-1"><strong>Device:</strong> {{ item.Device_Name }}</div>
                <div class="col-12 mt-1"><strong>Nature:</strong> {{ item.complain_Nature }}</div>
                <div class="col-12 border-top pt-2 mt-2">
                  <p class="mb-1 text-dark"><strong>Log:</strong> {{ item.complain_log }}</p>
                  <div class="text-right small-date">
                    <i class="far fa-clock mr-1"></i>{{ parseDateString(item.updated_date) }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="showModal" class="custom-modal-backdrop" @click.self="closeModal">
          <div class="custom-modal-content card shadow-lg border-0">
            <div class="card-header bg-white border-bottom-0 d-flex justify-content-between align-items-center pt-3 pb-0">
              <h5 class="mb-0 font-weight-bold text-primary">Complaint #{{ selectedComplain.complain_id }}</h5>
              <button type="button" class="close" @click="closeModal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            
            <div class="card-body custom-scrollbar">
              <div class="row">
                <div class="col-md-6 mb-3">
                  <p class="mb-1 text-muted small text-uppercase font-weight-bold">Submitted By</p>
                  <p class="mb-0">{{ selectedComplain.name }}</p>
                </div>
                <div class="col-md-6 mb-3">
                  <p class="mb-1 text-muted small text-uppercase font-weight-bold">Device Name</p>
                  <p class="mb-0"><span class="badge badge-light border text-dark">{{ selectedComplain.Device_Name }}</span></p>
                </div>
                <div class="col-md-6 mb-3">
                  <p class="mb-1 text-muted small text-uppercase font-weight-bold">Nature & Class</p>
                  <p class="mb-0">{{ selectedComplain.complain_Nature }} ({{ selectedComplain.complain_class }})</p>
                </div>
                <div class="col-md-6 mb-3">
                  <p class="mb-1 text-muted small text-uppercase font-weight-bold">Current Status</p>
                  <p class="mb-0"><span :class="getStatusClass(selectedComplain.status)" class="status-pill">{{ selectedComplain.status }}</span></p>
                </div>
                <div class="col-12 mb-3">
                  <p class="mb-1 text-muted small text-uppercase font-weight-bold">Summary / Log</p>
                  <div class="p-3 bg-light rounded text-dark">
                    {{ selectedComplain.complain_log || 'No summary provided.' }}
                  </div>
                </div>
                <div class="col-12 mb-3">
                  <p class="mb-1 text-muted small text-uppercase font-weight-bold">Proof / Attachment</p>
                  <div v-if="selectedComplain.proof_image_url" class="text-center bg-light p-2 rounded">
                    <img :src="selectedComplain.proof_image_url" alt="Complaint Proof" class="img-fluid rounded shadow-sm" style="max-height: 300px; object-fit: contain;">
                  </div>
                  <p v-else class="text-muted font-italic mb-0">No image attached.</p>
                </div>
              </div>
            </div>
            
            <div class="card-footer bg-white border-top-0 pb-3 text-right">
              <span class="text-muted small mr-3">Last Updated: {{ parseDateString(selectedComplain.updated_date) }}</span>
              <button class="btn btn-secondary btn-sm px-4" @click="closeModal">Close</button>
            </div>
          </div>
        </div>
  
        <div v-if="resultQuery.length === 0" class="text-center py-5 mt-4">
          <i class="fas fa-inbox fa-4x text-light mb-3"></i>
          <p class="text-muted">No complaints found</p>
        </div>
  
      </div>
    </div>
  </template>
  
  <script>
  import Navbar from './components/Navbar.vue';
  import { getAPI } from './axios-api.js'
  import moment from 'moment'
  
  export default {
      name: 'ComplainStatus',
      components: { Navbar },
      data() {
          return {
              searchQuery: '',
              complainData: [],
              showModal: false,
              selectedComplain: null
          }
      },
      created() {
          this.loadComplainStatus();
      },
      computed: {
        resultQuery() {
            if (this.searchQuery) {
                const search = this.searchQuery.toLowerCase();
                return this.complainData.filter((item) => {
                    // Ensure values exist before calling toLowerCase() to prevent errors
                    const name = item.name ? item.name.toLowerCase() : '';
                    const device = item.Device_Name ? item.Device_Name.toLowerCase() : '';
                    
                    return name.includes(search) || device.includes(search);
                });
            }
            return this.complainData;
        }
      },
      methods: {
          loadComplainStatus() {
              getAPI.get('/complainStatus/', {
                  headers: { Authorization: `Bearer ${localStorage.getItem('access_token')}` }
              })
              .then(response => {
                  this.complainData = response.data.Complain_Status;
                  console.log(this.complainData);
              })
              .catch(err => console.error(err));
          },
          parseDateString(date) {
              return moment(String(date)).format('DD/MM/YYYY hh:mm A')
          },
          getStatusClass(status) {
              const s = status.toLowerCase();
              if (s.includes('received')) return 'status-received';
              if (s.includes('investigation') || s.includes('initiated')) return 'status-pending';
              if (s.includes('completed') || s.includes('closed')) return 'status-completed';
              return 'status-default';
          },
          openModal(item) {
            this.selectedComplain = item;
            this.showModal = true;
            document.body.style.overflow = 'hidden'; // Prevents background scrolling
          },
          closeModal() {
              this.showModal = false;
              this.selectedComplain = null;
              document.body.style.overflow = 'auto';   // Restores scrolling
          },
      },
  }
  </script>
  
  <style scoped>
  .complain-status-page {
      background-color: #f4f7f6;
      min-height: 100vh;
  }
  
  .search-box .input-group-text {
      border-radius: 0.25rem 0 0 0.25rem;
  }
  
  .search-box input {
      border-radius: 0 0.25rem 0.25rem 0;
  }
  
  .status-pill {
      padding: 5px 12px;
      border-radius: 20px;
      font-size: 12px;
      font-weight: 600;
      display: inline-block;
      white-space: nowrap;
  }
  
  .status-received { background: #e3f2fd; color: #1976d2; }
  .status-pending { background: #fff3e0; color: #ef6c00; }
  .status-completed { background: #e8f5e9; color: #2e7d32; }
  .status-default { background: #eeeeee; color: #616161; }
  
  .mobile-card {
      border-radius: 10px;
      box-shadow: 0 4px 6px rgba(0,0,0,0.05);
  }
  
  .small-date {
      font-size: 11px;
      color: #aaa;
  }
  
  thead th {
      font-size: 13px;
      text-transform: uppercase;
      color: #777;
      border-top: none !important;
  }
  
  .table td {
      vertical-align: middle;
  }

  .clickable-row {
    cursor: pointer;
    transition: background-color 0.2s ease;
}

.clickable-row:hover {
    background-color: #f8f9fa !important;
}

/* Custom Modal Styling */
.custom-modal-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height:90vh;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1050;
    padding: 15px;
}

.custom-modal-content {
    width: 100%;
    max-width: 600px;
    max-height: 70vh;
    display: flex;
    flex-direction: column;
    animation: slideIn 0.3s ease-out;
}

.custom-scrollbar {
    overflow-y: auto;
}

.custom-scrollbar::-webkit-scrollbar {
    width: 6px;
}
.custom-scrollbar::-webkit-scrollbar-thumb {
    background-color: #ccc;
    border-radius: 4px;
}

@keyframes slideIn {
    from {
        opacity: 0;
        transform: translateY(-20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}
  </style>